const CohortSoftwareDevelopmentIcon = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_193_7913)">
        <circle cx="32" cy="28" r="28" fill="#28C846" />
        <path
          d="M25.333 37.9167L15.333 27.9167L25.4163 17.8333L27.208 19.625L18.9163 27.9167L27.1247 36.125L25.333 37.9167ZM38.583 38L36.7913 36.2083L45.083 27.9167L36.8747 19.7083L38.6663 17.9167L48.6663 27.9167L38.583 38Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default CohortSoftwareDevelopmentIcon;
